var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22.002,
    viewBox: "0 0 22 22.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home-run_1_",
    "data-name": "home-run (1)",
    d: "M21.409,9.57l0,0L12.432.594a2.025,2.025,0,0,0-2.865,0L.6,9.564l-.009.009a2.025,2.025,0,0,0,1.348,3.451q.031,0,.062,0h.358v6.6A2.373,2.373,0,0,0,4.727,22H8.238a.645.645,0,0,0,.645-.645V16.179A1.083,1.083,0,0,1,9.964,15.1h2.071a1.083,1.083,0,0,1,1.082,1.082v5.178a.645.645,0,0,0,.645.645h3.511a2.373,2.373,0,0,0,2.371-2.37v-6.6h.332A2.026,2.026,0,0,0,21.409,9.57Zm0,0",
    transform: "translate(0.001)",
    fill: "#5861ae"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBlue);
export default __webpack_public_path__ + "static/media/homeBlue.d7fa2164ba91e23d767c496cbd73eb65.svg";
export { ForwardRef as ReactComponent };